var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 10.9792H4.25C3.66917 10.9792 3.1875 10.4975 3.1875 9.91666C3.1875 9.33582 3.66917 8.85416 4.25 8.85416H29.75C30.3308 8.85416 30.8125 9.33582 30.8125 9.91666C30.8125 10.4975 30.3308 10.9792 29.75 10.9792Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 18.0625H4.25C3.66917 18.0625 3.1875 17.5808 3.1875 17C3.1875 16.4192 3.66917 15.9375 4.25 15.9375H29.75C30.3308 15.9375 30.8125 16.4192 30.8125 17C30.8125 17.5808 30.3308 18.0625 29.75 18.0625Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 25.1458H4.25C3.66917 25.1458 3.1875 24.6642 3.1875 24.0833C3.1875 23.5025 3.66917 23.0208 4.25 23.0208H29.75C30.3308 23.0208 30.8125 23.5025 30.8125 24.0833C30.8125 24.6642 30.3308 25.1458 29.75 25.1458Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.b5ee464deda0dee62a1fe91be5392685.svg";
export { ForwardRef as ReactComponent };